// ─── Stage Keys (snake_case — match backend StageKey constants) ───
export const StageKey = {
    New: 'new',
    QuotationRejected: 'quotation_rejected',
    QuotationPending: 'quotation_pending',
    QuotationApproved: 'quotation_approved',
    Sv1Scheduled: 'sv1_scheduled',
    Sv1Completed: 'sv1_completed',
    Sv2Proposed: 'sv2_proposed',
    Sv2Scheduled: 'sv2_scheduled',
    Sv2Completed: 'sv2_completed',
    InstallationScheduled: 'installation_scheduled',
    InstallationInProgress: 'installation_in_progress',
    InstallationCompleted: 'installation_completed',
    ClientReview: 'client_review',
    PendingOemSignoff: 'pending_oem_signoff',
    PendingAdminClosure: 'pending_admin_closure',
    ProjectCompleted: 'project_completed',
    OnHold: 'on_hold',
    Cancelled: 'cancelled',
};

// ─── Display Names (Title Case — returned by API as stageName / DisplayName) ───
export const StageName = {
    NewProject: 'New Project',
    QuotationRejected: 'Quotation Rejected',
    QuotationPending: 'Quotation Pending',
    QuotationApprovalPending: 'Quotation Approval Pending',
    QuotationApproved: 'Quotation Approved',
    Sv1Pending: 'SV1 Pending',
    Sv1Scheduled: 'SV1 Scheduled',
    Sv1Completed: 'SV1 Completed',
    Sv2Proposed: 'SV2 Proposed',
    Sv2Pending: 'SV2 Pending',
    Sv2Scheduled: 'SV2 Scheduled',
    Sv2Completed: 'SV2 Completed',
    InstallationScheduled: 'Installation Scheduled',
    InstallationInProgress: 'Installation In Progress',
    InstallationCompleted: 'Installation Completed',
    ClientReview: 'Client Review',
    PendingOemSignoff: 'Pending OEM Signoff',
    PendingAdminClosure: 'Pending Admin Closure',
    ProjectCompleted: 'Project Completed',
    Completed: 'Completed',
    Delivered: 'Delivered',
    OnHold: 'On Hold',
    Cancelled: 'Cancelled',
    PendingApproval: 'Pending Approval',
    QuotePending: 'Quote Pending',
    Scheduled: 'Scheduled',
    InProgress: 'In Progress',
};

// ─── Site Visit Booking Statuses (lowercase — from SupervisorSlotBooking.Status) ───
export const BookingStatus = {
    Proposed: 'proposed',
    Confirmed: 'confirmed',
    Completed: 'completed',
    Cancelled: 'cancelled',
    InProgress: 'inprogress',
};

// ─── Site Visit Request Statuses (from SiteVisitRequest — Title Case from API) ───
export const SiteVisitStatus = {
    Scheduled: 'Scheduled',
    InProgress: 'InProgress',
    Completed: 'Completed',
};

// ─── Quotation Statuses ───
export const QuotationStatus = {
    Draft: 'draft',
    Sent: 'sent',
    Approved: 'approved',
    Rejected: 'rejected',
    Expired: 'expired',
};

// ─── Quotation Types ───
export const QuotationType = {
    BaseWork: 'base_work',
    AdditionalWork: 'additional_work',
};

// ─── Payment Statuses ───
export const PaymentStatus = {
    Pending: 'pending',
    Paid: 'paid',
    Expired: 'expired',
};

// ─── Payment Link Statuses ───
export const PaymentLinkStatus = {
    Pending: 'pending',
    Created: 'created',
    Sent: 'sent',
    Paid: 'paid',
    Expired: 'expired',
    Cancelled: 'cancelled',
};

// ─── Document Type Codes ───
export const DocumentTypeCode = {
    ProjectDocument: 'project_document',
    HardwareList: 'hardware_list',
    QuotationPdf: 'quotation_pdf',
    InstallationPhoto: 'installation_photo',
    ProgressReport: 'progress_report',
    Sv1Photo: 'sv1_photo',
    Sv2Photo: 'sv2_photo',
    Bill: 'bill',
    InvoicePdf: 'invoice_pdf',
    SignoffPhoto: 'signoff_photo',
    DiscrepancyDoc: 'discrepancy_doc',
};

// ─── Document Reference Types ───
export const DocumentReferenceType = {
    Quotation: 'quotation',
    Bill: 'bill',
    Sv1Response: 'sv1_response',
    Sv2Response: 'sv2_response',
    InstallationChecklistResponse: 'installation_checklist_response',
    ProgressReport: 'progress_report',
    ClientReviewResponse: 'client_review_response',
    Request: 'request',
};

// ─── Request Types ───
export const RequestType = {
    Discrepancy: 'discrepancy',
    ExtraWork: 'extra_work',
    TeamRequest: 'team_request',
    TimelineChange: 'timeline_change',
    MaterialIssue: 'material_issue',
    DesignChange: 'design_change',
    Other: 'other',
};

export const RequestTypeLabel = {
    discrepancy: 'Discrepancy',
    extra_work: 'Extra Work',
    team_request: 'Team Request',
    timeline_change: 'Timeline Change',
    material_issue: 'Material Issue',
    design_change: 'Design Change',
    other: 'Other',
};

export const RequestStatus = {
    Open: 'open',
    InProgress: 'in_progress',
    Resolved: 'resolved',
    Rejected: 'rejected',
    Closed: 'closed',
};

export const RequestPriority = {
    Low: 'low',
    Medium: 'medium',
    High: 'high',
    Urgent: 'urgent',
};

// Helper: stages after SV1 completion (SV1 is definitely done)
export const POST_SV1_STAGES = [
    StageName.Sv1Completed,
    StageName.Sv2Proposed,
    StageName.Sv2Scheduled,
    StageName.Sv2Completed,
    StageName.InstallationScheduled,
    StageName.InstallationInProgress,
    StageName.InstallationCompleted,
    StageName.ClientReview,
    StageName.PendingOemSignoff,
    StageName.PendingAdminClosure,
    StageName.ProjectCompleted,
    StageName.Completed,
    StageName.Delivered,
];

export const POST_SV1_STAGE_KEYS = [
    StageKey.Sv1Completed,
    StageKey.Sv2Proposed,
    StageKey.Sv2Scheduled,
    StageKey.Sv2Completed,
    StageKey.InstallationScheduled,
    StageKey.InstallationInProgress,
    StageKey.InstallationCompleted,
    StageKey.ClientReview,
    StageKey.PendingOemSignoff,
    StageKey.PendingAdminClosure,
    StageKey.ProjectCompleted,
];

export const POST_SV2_STAGE_KEYS = [
    StageKey.Sv2Completed,
    StageKey.InstallationScheduled,
    StageKey.InstallationInProgress,
    StageKey.InstallationCompleted,
    StageKey.ClientReview,
    StageKey.PendingOemSignoff,
    StageKey.PendingAdminClosure,
    StageKey.ProjectCompleted,
];

// Helper: stages before site visits tab should show
export const PRE_SV_STAGES = [
    StageName.NewProject,
    StageName.QuotationPending,
    StageName.QuotationApprovalPending,
    StageName.QuotationApproved,
];
